import { render, staticRenderFns } from "./CreateProductType.vue?vue&type=template&id=00a233f2&scoped=true&"
import script from "./CreateProductType.vue?vue&type=script&lang=js&"
export * from "./CreateProductType.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductType.vue?vue&type=style&index=0&id=00a233f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a233f2",
  null
  
)

export default component.exports